export default {
	copy: 'This website uses cookies to ensure you get the best experience on our website. <a href="/pdf/cookie-tajekoztato.pdf" target="_blank">Cookie Policy</a>',
	button: 'Accept',
};
